// extracted by mini-css-extract-plugin
export default {"root":"XkBVn_","disabled":"C6fuLo"};